import { Form, Formik, Field } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import UIModal from "../../../../../shared/components/UIModal";
import ToggleSwitch from "../../../../../shared/components/ToggleSwitch";
import UploadLogo from "../../../../../shared/components/UploadLogo";
import InputField from "../../../../../shared/components/InputField";
import DropdownField from "../../../../../shared/components/DropdownField";
import faker from "faker";
import "./instituteBranchForm.scss";
import BoardService from "../../../../../services/CourseServices/BoardService/board.service";
import { deserialize, serialize } from "serializr";
import { BoardMetaModel } from "../../../../../models/CourseModels/BoardModel/board.model";
import ClassroomService from "../../../../../services/CourseServices/ClassroomService/classroom.service";
import BranchService from "../../../../../services/InstituteService/branch.service";
import { BranchValidationSchema } from "../../../instituteFormValidation";
import {
  Branch,
  BranchClassRoomsMetaModel,
} from "../../../../../models/InstituteModel/branches.model";
import { convertJSONToFormData } from "../../../../../shared/utils/converJsonToFormData";
import { Institutes } from "../../../../../models/InstituteModel/institutes.model";
import { useLocation } from "react-router-dom";
import Checkbox from "antd/lib/checkbox/Checkbox";
interface InstituteBranchFormProps {
  visible: boolean;
  closeHandler: () => void;
  data: any;
  refreshList: () => void;
}
const InstituteBranchForm: FC<InstituteBranchFormProps> = ({
  visible,
  closeHandler,
  data,
  refreshList,
}) => {
  const [initialValues, setInitialValues] = useState<any>({});
  const formRef = useRef<any>();
  const [boards, setBoards] = useState<any>();
  const [classes, setClasses] = useState<any>();
  const { state }: { state: Institutes } = useLocation();
  const [buttonLoading, setButtonLoading] = useState(false);

  const fetchBoards = () => {
    BoardService.getBoardsList(
      "",
      (response) => {
        let boards = deserialize(BoardMetaModel, response);
        setBoards(boards);
      },
      () => {},
      () => {}
    );
  };

  const fetchClassRooms = (id: any) => {
    let queryParams = `?board_id=${id}`;
    ClassroomService.getClassroomsList(
      queryParams,
      (classrooms: any) => {
        setClasses(classrooms);
      },
      () => {},
      () => {}
    );
  };

  const handleSubmit = (values: any) => {
    setButtonLoading(true);

    values["instituteId"] = state?.id;
    let jsonData = serialize(Branch, values);
    if (values?.logo) jsonData["logo"] = values["logo"];
    let formData = convertJSONToFormData({ branch: jsonData });

    if (data) {
      BranchService.updateBranch(
        data?.id,
        formData,
        () => {
          refreshList();
          closeHandler();
          setBoards([]);
          setClasses([]);
          formRef.current.resetForm(initialValues);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      );
    } else {
      BranchService.createBranch(
        formData,
        () => {
          refreshList();
          closeHandler();
          setBoards([]);
          setClasses([]);
          formRef.current.resetForm(initialValues);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      );
    }
  };

  useEffect(() => {
    fetchBoards();
    if (data) {
      fetchClassRooms(data?.board?.id);
    }
    setInitialValues({
      isActive: data ? data?.isActive : true,
      logo: null,
      name: data?.name,
      contactPerson: data?.contactPerson,
      registeredAddress: data?.registeredAddress,
      email: data?.email,
      phoneNumber: data?.phoneNumber,
      branchClassRooms: data?.classRooms || [],
      boardId: data?.board?.id,
    });
  }, [data, visible]);
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      validationSchema={BranchValidationSchema}
      enableReinitialize
      innerRef={formRef}
    >
      {({ values, setFieldValue, resetForm }) => (
        <UIModal
          visible={visible}
          closeModal={() => {
            setBoards([]);
            setClasses([]);
            closeHandler();
          }}
          onClosed={() => {
            resetForm();
          }}
          submitProps={{
            text: data ? "Update" : "Create",
            clickHandler: () => {
              handleSubmit(values);
            },
            buttonLoading: buttonLoading,
          }}
          cancelProps={{
            text: "Cancel",
            clickHandler: () => {
              setBoards([]);
              setClasses([]);
              closeHandler();
            },
          }}
          className="institute-branch-form__container"
        >
          <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <div className="institute-branch-form__header">
              <div className="institute-branch-form__title">
                {data ? "Update Branch" : "Create New Branch"}
              </div>
              <div className="institute-branch-form__toggle">
                <Field name="isActive" as="switch">
                  <ToggleSwitch
                    checked={values?.isActive}
                    handleChange={(checked) => {
                      setFieldValue("isActive", checked);
                    }}
                  />
                </Field>
              </div>
            </div>

            <Field name="logo" as="file-upload">
              <UploadLogo
                logoUrl={values?.logo ? values?.logo : data?.logoUrl}
                setFile={(_, file) => setFieldValue("logo", file)}
              />
            </Field>
            <div className="institute-branch-form__input">
              <div className="institute-branch-form__label">Branch Name</div>
              <InputField
                type="text"
                name="name"
                placeholder="Type branch name"
              />
            </div>
            <div className="institute-branch-form__input">
              <div className="institute-branch-form__label">Board</div>
              <DropdownField
                name="boardId"
                placeholder="Select board"
                options={boards}
                value={values?.boardId}
                onChange={(value) => {
                  setFieldValue("boardId", value);
                  fetchClassRooms(value);
                }}
                showSearch={false}
                optionFilterProp="label"
              />
            </div>
            <div className="institute-branch-form__input">
              <div className="institute-branch-form__label">
                Configure Classes
              </div>
              <div className="configure-classes___wrapper">
                {classes?.length ? (
                  <div>
                    <Checkbox
                      checked={
                        values?.branchClassRooms?.length == classes?.length
                      }
                      onChange={(checked) => {
                        if (checked.target.checked) {
                          let selectAll: any = deserialize(
                            BranchClassRoomsMetaModel,
                            classes
                          );
                          setFieldValue("branchClassRooms", [...selectAll]);
                        } else {
                          setFieldValue("branchClassRooms", []);
                        }
                      }}
                    >
                      Select all
                    </Checkbox>
                    {classes?.map((value, index) => {
                      return (
                        <div className="configure-class__container">
                          <p>{value?.name}</p>
                          <ToggleSwitch
                            checked={
                              values?.branchClassRooms?.filter(
                                (boardClass) =>
                                  boardClass?.classRoomId == value?.id
                              )?.length
                            }
                            handleChange={(checked) => {
                              if (
                                checked &&
                                !values?.branchClassRooms?.filter(
                                  (boardClass) =>
                                    boardClass?.classRoomId == value?.id
                                )?.length
                              ) {
                                let classRooms: any[] =
                                  values?.branchClassRooms;
                                classRooms?.push({
                                  classRoomId: value?.id,
                                });
                                setFieldValue("branchClassRooms", [
                                  ...classRooms,
                                ]);
                              } else if (
                                !checked &&
                                values?.branchClassRooms?.filter(
                                  (boardClass) =>
                                    boardClass?.classRoomId == value?.id
                                )?.length
                              ) {
                                let classRooms =
                                  values?.branchClassRooms?.filter(
                                    (boardClass) =>
                                      boardClass?.classRoomId !== value?.id
                                  );

                                setFieldValue("branchClassRooms", [
                                  ...classRooms,
                                ]);
                              } else {
                                // do nothing
                              }
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="no-classes__text">No classes</p>
                )}
              </div>
            </div>
            <div className="institute-branch-form__input">
              <div className="institute-branch-form__label">Contact Person</div>
              <InputField
                type="text"
                name="contactPerson"
                placeholder="Type name"
              />
            </div>
            <div className="institute-branch-form__input">
              <div className="institute-branch-form__label">Email</div>
              <InputField
                type="text"
                name="email"
                placeholder="Type email address"
              />
            </div>
            <div className="institute-branch-form__input">
              <div className="institute-branch-form__label">Phone Number</div>
              <InputField
                type="text"
                name="phoneNumber"
                placeholder="Type number"
                prefix={"+91"}
              />
            </div>
            <div className="institute-branch-form__input">
              <div className="institute-branch-form__label">
                Registered Address
              </div>
              <InputField
                type="textarea"
                name="registeredAddress"
                placeholder="Type here .."
              />
            </div>
          </Form>
        </UIModal>
      )}
    </Formik>
  );
};

export default InstituteBranchForm;
